import { fromUnixTime, formatRFC3339 } from 'date-fns'

const charts = {
  data: () => ({
    dataLabelMapping: {
      ASC: '实际风速系数',
      APC: '实际功率系数',
      TPC: '理论功率系数'
    }
  }),
  methods: {
    chartsTransformHistoricalFunc (timeLabel, dataLabel){
      return (d) => [ d[timeLabel] * 1000, (Math.round(d[dataLabel] * 100) / 100).toFixed(2) ]
    },
    chartsCarbonTransformTimeseries (data, timeLabel, dataLabels){
      let transformed = []
      dataLabels.forEach( label => {
        transformed = transformed.concat( data.map( (d) => ({ group: this.dataLabelMapping[label], date: formatRFC3339(fromUnixTime(d[timeLabel]), {fractionDigits: 3}), value: (Math.round(d[label] * 100) / 100).toFixed(2) }) ) )
      })
      return transformed
    }
  }
}

export default charts